<template>
<v-dialog
    v-model="dialog"
    max-width="1250"
    v-if="template != null"
>
    <v-card>
        <v-card-title>{{template.label}}</v-card-title>

        <v-card-text>
            <v-text-field
                label="Label"
                v-model="template.label"
            />

            <v-select
                label="Industries"
                :items="$rc.enumChoices('industry_code', false)"
                v-model="template.industries"
                multiple
            />

            <v-select
                label="State"
                :items="$rc.enumChoices('bulk_message_template_state', false)"
                v-model="template.state"
            />

            <v-select
                label="Types"
                :items="$rc.enumChoices('bulk_message_template_type', true, 'Any Type')"
                v-model="template.types"
                multiple
            />

            <v-select
                label="Message Type (Consent Category)"
                :items="[
                    {'text': 'Informational', 'value': 'informational'},
                    {'text': 'Promotional', 'value': 'promotional'},
                ]"
                v-model="template.consent_category"
                :disabled="template.is_double_opt_in_message"
            />

            <v-checkbox
                v-model="template.is_double_opt_in_message"
                label="This template starts a double opt-in process"
                @change="onToggleDoubleOptIn"
            />


           <v-alert
                v-if="template.is_double_opt_in_message"
                        type="warning"
                        outlined
                        class="mb-4"
                    >
                        <strong>This is not legal advice. Consult an Attorney if you have legal or compliance questions about your text marketing campaigns.</strong>
                        <p>RedChirp provides users with a template message that might be used to obtain affirmative written consent for marketing and promotional messages from individuals on your contact list. As with any marketing campaign, you should consider the target audience, risks of reassigned or incorrect numbers, recent interactions with the customer, and what, if any, existing consent you already have from your customer base. Keep in mind that as time passes since the customer provided you their number there's increased risk that the number no longer belongs to the person that provided it.</p>
                        <p>We recommend against adding any promotional, incentive, or marketing language to this message. When in doubt, complicated legal questions should be raised with an attorney experienced in telemarketing compliance.</p>
           </v-alert>

            <m-edit-blobs
                label="Image (optional)"
                empty_text="No image"
                v-model="template.blob_ids"
                :process_media="true"
                :externally_visible="true"
                :allow_multiple="false"
                :limit_to_size="460800"
                style="padding-bottom: 7px; margin-bottom: 15px; border-bottom: 1px solid rgb(148,148,148); margin-top: 15px"
                edit_icon="mdi-lead-pencil"
                dialog_title="Bulk Message Template Image"
                dialog_hint="<b>Image limitations:</b>  Images <b>must</b> be 450 Kb or smaller.<br/><br/><b>Image size:  </b>For best results, images should be square or close to square.  The ideal image size is 400 x 400 pixels."
            />

            <m-edit-message-patterns
                ref="message-patterns"
                v-model="template.message_patterns"
                context="bulk-message"
                :always_mms="false"
                :trigger_save="save_requested"
                v-on:save-requested="onSaveRequested"
                v-on:save-triggered="onSaveTriggered"
            />
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Save
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            dialog: false,
            template: null,
            save_requested: false,
        }
    },

    methods: {

        showDialog(template_id)
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'GET: /api/v1/bulk/templates/:template_id',

                'params' : {
                        'template_id': template_id,
                    },

                'on_success': (data) => {
                        this.template = data;
                        this.dialog = true;
                    },

                'on_error': 'Unable to load template',
            });
        },

        showDialogCreate(stub)
        {
            this.template = _.cloneDeep(stub);
            this.dialog = true;
        },

        onOk()
        {
            // Trigger save via event-driven flow; child will check for shortened links
            this.save_requested = true;
        },

        onSaveRequested()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/bulk/templates',

                'params' : this.template,

                'on_success': (data) => {
                        this.dialog = false;
                        this.$emit('input', this.template);
                        this.save_requested = false;
                    },

                'on_error': 'Unable to save template',
            });
        },

        onSaveTriggered()
        {
            // Reset the trigger so it can be used again
            this.save_requested = false;
        },

        onToggleDoubleOptIn()
        {
            if (this.template && this.template.is_double_opt_in_message)
            {
                // Double opt-in templates must send the initial message as informational
                this.template.consent_category = 'informational';
            }
        },

        onCancel()
        {
            this.dialog = false;
        },


    },
}
</script>

<style lang="scss" scoped>
</style>